// extracted by mini-css-extract-plugin
export var blockFollow = "footer-module--blockFollow--6d03f";
export var boxFooter = "footer-module--boxFooter--12653";
export var colMenu = "footer-module--colMenu--c9987";
export var footerLegal = "footer-module--footerLegal--3eb67";
export var footerPage = "footer-module--footerPage--d8da3";
export var listNavFooter = "footer-module--list-nav-footer--cafd1";
export var menuPrefooter = "footer-module--menuPrefooter--2dcfe";
export var privacy = "footer-module--privacy--3d425";